import React from 'react';
import { Alert } from 'antd';

import './index.less';

export default React.forwardRef((props, ref) => {
  const msg = props.msg;
  if (!msg) return null;

  return (
    <div className="err-msg-wrap" style={{ marginLeft: '28px', marginRight: '28px' }}>
      <Alert message={msg} type="error" showIcon />
    </div>
  );
});
